// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"227":"3b1f1d47","232":"35cf269e","237":"81256569","526":"3f82df94","872":"3c7d1f56"}[chunkId] + ".chunk.js";
};